import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { Toast } from './../UI/toast/Toast';
import { Button, Col, Row, Spinner } from 'reactstrap';
import { update, updateCondominiumImage } from '../../helpers/api/condominium';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage, { getErrorMessage } from '../../helpers/errors/handleErrorMessage';
import withRedirect from '../../helpers/hoc/withRedirect';
import PageHeader from '../common/PageHeader';
import CreateCondominiumForm from './CreateCondominiumForm';
import { findOne } from '../../helpers/api/condominium'
import { useDispatch, useSelector } from 'react-redux';
import { NMR } from '../../actions/condominiumActions';
import { useHistory } from 'react-router-dom';

const EditCondominium = ({ setRedirect }) => {

    const { role } = useSelector(state => state.auth.user);
    const history = useHistory();
    const { id } = useParams();
    const dispatch = useDispatch();

    if (!id || isNaN(id)) { setRedirect(true); }

    const [condominium, setCondominium] = useState({ data: null, isLoading: true, error: null })
    const { data, isLoading } = condominium;

    useEffect(() => {
        let isMounted = true;
        if (id) {
            const getDetails = () => {
                findOne(id)
                    .then(({ data }) => setCondominium(prev => ({ ...prev, data: data })))
                    .catch(({ error, code }) => { handleErrorMessage(error); setCondominium(prev => ({ ...prev, error: getErrorMessage(code) })) })
                    .finally(() => setCondominium(prev => ({ ...prev, isLoading: false })))
            }
            isMounted && getDetails();
        }
        if (data) dispatch(NMR())
        return () => {
            setCondominium({ data: null, isLoading: true, error: null });
            isMounted = false;
        }
        // eslint-disable-next-line
    }, []);

    const handleEdit = async (values) => {
        try {
            const response = await update(id, values);
            saveImage(values);
            if (response.code === SUCCESS_RESPONSE.OK) {
                Toast.fire({
                    type: 'success',
                    title: `Se han guardado los cambios satisfactoriamente.`,
                });
                if (role === 'manager') {
                    setRedirect(true);
                } else if (role === 'root') {
                    history.push(`/root/condominiums`)
                }
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    const saveImage = async (values) => {
        if (values.image) {
            try {
                let form = new FormData();
                form.append('picture', values.image);
                const response = await updateCondominiumImage(id, form);
                if (response.code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({
                        type: 'success',
                        title: `Se han cambiado la foto del condominio satisfactoriamente.`,
                    });
                    history.push(`/dashboard/condominiums`);
                }
            } catch (error) {
                handleErrorMessage(error);
            }
        }
    }

    const loadingWhileWaiting = () => (
        <Row className="justify-content-center vh-100 align-items-center">
            <Col sm={8} className="d-flex justify-content-center">
                <Spinner />
            </Col>
        </Row>
    )

    return <>
        {isLoading ? loadingWhileWaiting() :
            <>
                <PageHeader
                    title={`Editar condominio - ${data?.name || ''}`}
                    titleTag="h2"
                    description=""
                    className="mb-3"
                    col={{ lg: 9 }}
                >
                    <Button color="link" size="sm" className="pl-0" to="#!">
                        Tienes alguna pregunta? chatea con nosotros.
                    </Button>
                </PageHeader>
                <CreateCondominiumForm condominium={data} handleSubmitData={handleEdit} />
            </>
        }
    </>
}

export default withRedirect(EditCondominium);